import { createSelector } from '@ngrx/store';
import { AppState } from '../app.reducer';
import { stateSelector } from 'app/store/state.selectors';
import { paymentTypesSelector } from 'app/store/organization.selectors';
import { discountIsLoadingSelector, discountsSelector } from 'app/store/discounts.selectors';
import { PromoCodeStatus, WrongCouponNumberCode } from 'app/models/order-discount-info.model';

export interface CartTotal {
  quantity: number;
  price: number;
}

export const cartSelector = createSelector(
  (state: AppState) => {
    return state.cart;
  },
  cart => cart
);

export const cartProducts = createSelector(
  cartSelector,
  cart => cart.products
);

export const cartPaymentTypeIdSelector = createSelector(
  cartSelector,
  cart => cart.paymentTypeId
);

export const cartCommentSelector = createSelector(
  cartSelector,
  cart => cart.comment
);

export const cartPromoCodeStatusSelector = createSelector(
  cartSelector,
  discountsSelector,
  (cart, discounts) => {
    let promoCodeStatus: PromoCodeStatus = PromoCodeStatus.NotChecked;
    if (discounts.warnings.find(x => x.code === WrongCouponNumberCode)) {
      //TODO: Пока эта логика завязана на iiko, надо будет решить в т.ч. на сервере
      promoCodeStatus = PromoCodeStatus.InCorrect;
    } else if (!discounts.isLoading && cart.promoCode?.length) {
      promoCodeStatus = PromoCodeStatus.Correct;
    }

    return promoCodeStatus;
  }
);

export const cartPromoCodeSelector = createSelector(
  cartSelector,
  (cart) => {
    return cart.promoCode;
  }
);

export const cartTotal = createSelector(
  cartProducts,
  (
    products
  ) => {
    let price = 0;
    let quantity = 0
    products.forEach(product => {
      const groupModifiersSum = product.groups.length ?
        product.groups.map(
          group => group.modifiers.length ?
            group.modifiers.map(m => m.calculatedPrice * m.selectedQuantity).reduce((a, b) => a + b)
            : 0).reduce((a, b) => a + b)
        : 0;

      price += product.quantity * (product.price + groupModifiersSum);
      quantity += product.quantity;
    });
    const total: CartTotal = {
      quantity: quantity,
      price: price,
    };
    return total;
  });

export const cartTotalSelector = createSelector(
  cartProducts, cartTotal, stateSelector, cartPaymentTypeIdSelector, paymentTypesSelector,
  cartCommentSelector, cartPromoCodeSelector, discountsSelector, discountIsLoadingSelector,
  (
    products, total, currentState,
    paymentTypeId, paymentTypes, comment, promoCode, discountState, discountIsLoading
  ) => ({
    products,
    total,
    currentState,
    paymentTypeId,
    paymentTypes,
    comment,
    discountState,
    promoCode,
    discountIsLoading
  })
);
